import { render, staticRenderFns } from "./DisplayTips.vue?vue&type=template&id=72d1480d"
import script from "./DisplayTips.vue?vue&type=script&lang=ts"
export * from "./DisplayTips.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports